module.exports = __webpack_public_path__ + "img/info-button.76b26330.png";